<script setup>

import notification from "@/utils/plugins/NotificationService";
import { onMounted, ref } from 'vue';
import { useUiStore } from "@/app/stores/uiStore";
import MaterialTypeService from '@/api/services/materialType.service';
import MaterialRequestService from '@/api/services/materialRequest.service';

// eslint-disable-next-line no-undef
const emit = defineEmits(['closeDialog'])

const requestForm = ref({
    materialType: null,
    description: '',
})

const materialTypes = ref([]);
const uiStore = useUiStore();

onMounted(() => {
    getMaterialsTypes();
})

const closeDialog = (saved = false) => {
    emit('closeDialog', saved)
}

const saveEntry = () => {
    if (!requestForm.value.materialType) {
        notification.addNotification({
            type: 'error',
            message: 'Tienes que seleccionar un tipo de material',
            duration: 6000
        })
        return;
    }

    const params = {
        description: requestForm.value.description || '',
        systemsComment: '',
        status: 'pending',
        materialType: requestForm.value.materialType['@id'],
    };

    uiStore.startLoading();
    MaterialRequestService.createMaterialRequest(params)
        .then((res) => {
            if (res && (res.status === 200 || res.status === 201)) {
                notification.addNotification({
                    type: 'success',
                    message: 'Solicitud creada correctamente',
                    duration: 6000
                })
                closeDialog(true);
            }
            uiStore.stopLoading();
        })
        .catch(() => {
            uiStore.stopLoading();
        })
}

const getMaterialsTypes = () => {
    const param = {
        page: 1,
        itemsPerPage: 99999,
    }
    uiStore.startLoading();
    MaterialTypeService.getMaterialTypes(param)
        .then((res) => {
            if (res.status === 200) {
                materialTypes.value = res.data['hydra:member']
            }
            uiStore.stopLoading();
        })
        .catch(() => {
            uiStore.stopLoading();
        })
}

</script>

<template>
    <div>
        <div class="header">
            <img style="width: 30px; margin-bottom: 14px;" src="@/assets/icons/box-blue.svg">
            <span class="header-title pl-4">
                Solicitar material
            </span>
        </div>
        <div class="row f-flex">
            <div class="col-12 el-col-xs-24 mt-3">
                <label for="requestMaterialType" class="w-100">Tipo de material</label>
                <el-select popper-class="material-modal-select" id="requestMaterialType" v-model="requestForm.materialType" filterable clearable
                    placeholder="Seleccione el tipo de material a solicitar" :value-key="'@id'">
                    <el-option v-for="item in materialTypes" :key="item['@id']" :label="item.name" :value="item" />
                </el-select>
            </div>
            <div class="col-12 mt-3">
                <label for="requestMaterialDescription" class="w-100">Descripción material</label>
                <el-input id="requestMaterialDescription" type="textarea" v-model="requestForm.description"
                    placeholder="Escribe tus comentarios" :rows="5" class="custom-textarea" />
            </div>

        </div>
        <div class="row footer">
            <div class="col-md-12 mt-4 footer-container">
                <div class="d-flex justify-content-end gap-3">
                    <div class="col-md-3">
                        <button class="btn btn-block btn_yellow edit-button" @click="closeDialog">
                            Cancelar
                        </button>
                    </div>
                    <div class="col-md-3">
                        <button type="submit" class="btn btn-block btn_red edit-button" @click="saveEntry">
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.header-title {
    font-size: 30px;
    margin-left: 5px;
    font-weight: 800;
    letter-spacing: -0.05em;
    color: #474ce6;
}

.custom-textarea:deep(.el-textarea__inner) {
    font-size: 14px !important;
    border-radius: 20px;
}

.footer-container {
    margin-left: -10px;
}

@media (max-width: 767.98px) {
    .footer-container {
        margin-left: 0 !important;
    }

    .row {
        margin-left: 0;
        margin-right: 0;
    }

    [class*="col-"] {
        padding-left: 0;
        padding-right: 0;
    }

    .footer {
        .d-flex {
            flex-direction: column;
            gap: 0.75rem !important;
        }

        .col-md-3 {
            width: 100%;
        }

        .edit-button {
            width: 100%;
        }
    }
}

@media (max-width: 500px) {
    .header-title {
        font-size: 25px;
    }
}
</style>
